import {FormattedMessage} from "react-intl";
import {FaGlobe} from "react-icons/fa";
import {contactMethodsLinks} from "@utils/types/contactMethodsTypes";
import SetInnerHtml from "@components/setInnerHtml";

import "./style.scss";

const SocialMedia = ({data}) => {
    if (!data?.length)
        return;

    return (
        <div className="social-media-request">
        {/*    <h2 className="social-media-title">
                <FormattedMessage id="socialMedia"/>
            </h2>*/}

            <div className="social-media-request-items">
                {data?.map((item) => (
                    <a
                        href={contactMethodsLinks(item.type, item.value)}
                        rel="noreferrer"
                        target="_blank"
                        title={`${item.title}: ${item.value}`}
                        key={item.id}
                        className="social-media-request-items-item"
                    >
                        <SetInnerHtml html={item.icon} className="d-flex"/>
                    </a>
                ))}
            </div>
        </div>

    );
};

export default SocialMedia;